import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, ArrowRight } from "lucide-react";

export const WorkspaceSetupGate = () => {
  const { user, checkAuth } = useAuth();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  // Only block when consent is already handled, so the two gates don't overlap.
  if (user?.requires_consent) return null;
  if (!user?.workspace_setup_needed) return null;

  const save = async () => {
    if (name.trim().length < 2) { toast.error("Enter a workspace name"); return; }
    setBusy(true);
    try {
      await api.post("/auth/complete-workspace", { name: name.trim() });
      await checkAuth();
      toast.success("Workspace ready!");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save");
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-slate-900/60 backdrop-blur-sm grid place-items-center p-4" data-testid="workspace-setup-gate">
      <div className="w-full max-w-lg rounded-xl bg-white shadow-xl p-7">
        <div className="flex items-center gap-2 text-[#2563EB]"><Building2 className="h-5 w-5" /><p className="overline">Workspace</p></div>
        <h2 className="mt-2 text-xl font-bold tracking-tight text-slate-900">Create your workspace</h2>
        <p className="mt-2 text-sm text-slate-600">Your workspace is where your projects, team and company data will live.</p>
        <div className="mt-5 space-y-2">
          <Label className="text-xs font-medium text-slate-600">Workspace name</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Acme Inc."
            onKeyDown={(e) => e.key === "Enter" && save()} data-testid="workspace-setup-name" />
        </div>
        <Button onClick={save} disabled={busy || name.trim().length < 2} className="mt-6 w-full bg-[#2563EB] hover:bg-[#1d4ed8]" data-testid="workspace-setup-submit">
          {busy ? "Creating…" : "Create Workspace"}
          {!busy && <ArrowRight className="ml-2 h-4 w-4" />}
        </Button>
      </div>
    </div>
  );
};
